/*!

=========================================================
* Now UI Dashboard React - v1.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/now-ui-dashboard.scss?v1.4.0";
import "assets/css/demo.css";

import AdminLayout from "layouts/Admin.js";
import LoginLayout from "layouts/Login.js";
import ScrollToTop from "./components/ScrollToTop"
import { FetchCategoria } from './components/FetchCategoria';
import { AddCategoria } from './components/AddCategoria'; 

import { FetchAnuncios } from './components/FetchAnuncios';
import { AddAnuncios } from './components/AddAnuncios';
import { AddSuscripcion } from './components/AddSuscripcion';
import { VerSuscripcion } from './components/VerSuscripciones';

import { AprobarAnuncio } from './components/AprobarAnuncio';
import { VerAprobacion } from './components/VerAprobacion';
import { Administrador } from './components/Administrador';

import { AnunciosPrincipal } from './components/AnunciosPrincipal'; 
import { VerAnuncio } from './components/VerAnuncio';
import { Historico } from "./components/AnunciosHistorial";

import { AnunciosComunicado } from './components/AnunciosComunicado';
import { VerComunicado } from './components/VerComunicado';
import { VerHistorial } from './components/VerHistorial';

import { LogCas } from './components/LogCas';
import url from "./variables/url.js";
import * as dotenv from 'dotenv';
import App from './App';

import { getCookie, checkCookie } from "./variables/espolAds.js";

import CasClient, { constant } from "react-cas-client";
import { authService } from './services/auth.service';

const CAS_PARAMS = url.cas.split("://");
const casOptions = { version: constant.CAS_VERSION_2_0, path: '/', protocol: CAS_PARAMS[0] };
const casClient = new CasClient(CAS_PARAMS[1], casOptions);

const hist = createBrowserHistory();

ReactDOM.render(
    <Router history={hist}>        
        {/*<ScrollToTop>*/}
        {/*<Switch>*/}
        {/*    <Route path="/admin" render={(props) => <AdminLayout {...props} />} />*/}
        {/*    <Route path="/login" render={(props) => <LoginLayout {...props} />} />             */}
        {/*    <AdminLayout>*/}
        {/*        <Route exact path="/admin" />*/}
        {/*        <Route exact path="/fetch-categoria" component={FetchCategoria} />*/}
        {/*        <Route exact path="/add-categoria" component={AddCategoria} />*/}
        {/*        <Route path='/categoria/edit/:id' component={AddCategoria} />*/}

        {/*        <Route exact path="/fetch-anuncios" component={FetchAnuncios} />*/}
        {/*        <Route exact path="/add-anuncios" component={AddAnuncios} />                    */}
        {/*        <Route path='/creator/anuncios/edit/:id' component={AddAnuncios} />*/}
        {/*        <Route exact path="/aprobar-anuncio" component={AprobarAnuncio} />*/}
        {/*        <Route exact path="/user-admin" component={Administrador} />*/}
        {/*        <Route exact path="/anuncios" component={AnunciosPrincipal} />*/}
        {/*        <Route path='/ver-anuncio/:id' component={VerAnuncio} />*/}
        {/*        <Route path="/espoluser/historico" component={Historico} />*/}

        {/*        <Route exact path="/mis-comunicados" component={AnunciosComunicado} />*/}
        {/*        <Route exact path="/ver-comunicado/:id" component={VerComunicado} />*/}
        {/*        <Route exact path="/ver-historial/:id" component={VerHistorial} />*/}

        {/*        <Route exact path="/ver-aprobacion/:id" component={VerAprobacion} />*/}
        {/*        <Route exact path="/LogCas" component={LogCas} />                */}

        {/*        <Route exact path="/add-suscripcion" component={AddSuscripcion} />*/}
        {/*        <Route path='/general/ver-suscripcion' component={VerSuscripcion} />*/}
        {/*            <Route exact path="/">*/}
        {/*                <Redirect to="/general/principal" />*/}
        {/*            </Route>*/}
        {/*    </AdminLayout>*/}
        {/*    <LoginLayout>*/}
        {/*        <Route exact path="/login" />                */}
        {/*    </LoginLayout>*/}
        {/*    <Redirect to="/admin/dashboard" />*/}
        {/*    </Switch>*/}
        {/*    </ScrollToTop>           */}
        <App />
  </Router>,
  document.getElementById("root")
);
